import React, { useState } from "react";
import styles from "../../css/AddField.module.css";
import dropDownArrow from "../../assets/icons/down-arrow.svg";
import closeIcon from "../../assets/icons/Close-green.svg";

const COLUMN_OPTIONS = ["Column 1", "Column 2", "Column 3"];

export default function AddField({ onClose }) {
  const [fieldName, setFieldName] = useState("");
  const [mapColumn, setMapColumn] = useState("");

  const handleSubmit = () => {
    if (fieldName && mapColumn) {
      console.log("Added Field:", { fieldName, mapColumn });
      setFieldName("");
      setMapColumn("");
      if (onClose) onClose();
    }
  };

  return (
    <div className={styles.backdrop}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.heading}>Add Field</h2>
          <button onClick={onClose} className={styles.closeBtn}>
            <img src={closeIcon} alt="Close" />
          </button>
        </div>

        <div className={styles.content}>
          <p className={styles.description}>
            Add new field details below.
          </p>

          <div className={styles.fieldGroup}>
            <label className={styles.label}>
              <span className={styles.required}>*</span>Field Name
            </label>
            <input
              type="text"
              value={fieldName}
              onChange={(e) => setFieldName(e.target.value)}
              placeholder="Type Name"
              className={styles.inputField}
            />
          </div>

          <div className={styles.fieldGroup}>
            <label className={styles.label}>
              <span className={styles.required}>*</span> Select Field
            </label>

            <div className={styles.selectWrapper}>
              <select
                value={mapColumn}
                onChange={(e) => setMapColumn(e.target.value)}
                className={`${styles.selectField} ${mapColumn ? styles.hasValue : ""}`}
              >
                <option value="" disabled hidden>
                  Map Column
                </option>
                {COLUMN_OPTIONS.map((col) => (
                  <option key={col} value={col}>
                    {col}
                  </option>
                ))}
              </select>

              <span className={styles.selectArrow}>
                <img src={dropDownArrow} alt="dropdown"/>
              </span>
            </div>
          </div>

          <div className={styles.footer}>
            <button onClick={onClose} className={styles.cancelBtn}>
              Cancel
            </button>
            <button onClick={handleSubmit} className={styles.addBtn}>
              Add
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}